import { IElectionSettings } from "@/interfaces/ShowNormalElectionProps";
import { Typography, FormControl, InputLabel, Select, FormControlLabel, Checkbox, Tooltip, Box } from "@mui/material";
import Grid2 from '@mui/material/Grid2';
import React from "react";
import { useTranslation } from "react-i18next";
import { logger } from '@/lib/logger';


export default function CreateSettings(props: { electionSettings: IElectionSettings, setElectonSettings: (electionSettings: IElectionSettings) => void; }): React.JSX.Element {
    const { t } = useTranslation("election");

	logger.debug('CreateSettings props', { props });

	return (
		<Grid2 container alignItems="flex-start"
			justifyContent="flex-start"
			rowSpacing={0.75}
			columnSpacing={0}
		>
			<Grid2 size={{ xs: 12 }} >
				<Typography>{t("ballot_settings")}</Typography>
			</Grid2>
			<Grid2 container size={{ xs: 12 }} rowSpacing={0.75} columnSpacing={1.25}>
				<Grid2 size={{ xs: 12, md: 4 }}>
				<Tooltip title={<div><b>{t("settings_type_chip")}</b> {t("settings_type_chip_tooltip")}<br /><b>{t("settings_type_table")}</b> {t("settings_type_table_tooltip")}<br /><b>{t("settings_type_ballot")}</b> {t("settings_type_ballot_tooltip")}</div>}>
					<FormControl variant="outlined" fullWidth>
						<InputLabel id="norm_type-label" htmlFor="type">
							{t("type")}
						</InputLabel>
						<Select
							labelId="norm_type-label"
							label={t("type")}
							native
							value={props.electionSettings.type}
							error={props.electionSettings.type == 0}
							onChange={(e) =>
								props.setElectonSettings({ ...props.electionSettings, type: e.target.value as number })
							}
						>
							{/* <option value='' default>Select</option> */}
							<option value={0}>{t("purpose_select")}</option>
							<option value={1}>{t("settings_type_chip")}</option>
							<option value={2}>{t("settings_type_table")}</option>
							<option value={3}>{t("settings_type_ballot")}</option>
						</Select>
					</FormControl>
				</Tooltip>
				</Grid2>
				<Grid2
					size={{ xs: 12, md: 8 }}
					sx={{ mt: { xs: 0, md: -0.5 }, pl: { xs: 0, md: 1.5 } }}
				>
					<Box sx={{ width: "100%" }}>
						<Grid2 container rowSpacing={0.25} columnSpacing={1.25}>
					<Grid2 size={{ xs: 6 }}>
						<Tooltip title={<div>{t("settings_limit_votes_tooltip")}</div>}>
							<Box>
								<FormControlLabel
									sx={{ m: 0, width: "100%", '& .MuiFormControlLabel-label': { fontSize: '0.95rem' } }}
									control={
										<Checkbox
											size="small"
											sx={{ p: 0.45 }}
											checked={props.electionSettings.constraints.limit_votes}
											onChange={(e) => {
												props.setElectonSettings({ ...props.electionSettings, constraints: { ...props.electionSettings.constraints, limit_votes: e.target.checked } });
											}}
											inputProps={{ "aria-label": t("settings_limit_votes") }}
										/>
									}
									label={t("settings_limit_votes")}
								/>
							</Box>
						</Tooltip>
					</Grid2>
					<Grid2 size={{ xs: 6 }}>
						<Tooltip title={<div>{t("settings_duplicates_tooltip")}</div>}>
							<Box>
								<FormControlLabel
									sx={{ m: 0, width: "100%", '& .MuiFormControlLabel-label': { fontSize: '0.95rem' } }}
									control={
										<Checkbox
											size="small"
											sx={{ p: 0.45 }}
											checked={!props.electionSettings.constraints.no_duplicates}
											onChange={(e) => {
												props.setElectonSettings({ ...props.electionSettings, constraints: { ...props.electionSettings.constraints, no_duplicates: !e.target.checked } });
											}}
											inputProps={{ "aria-label": t("settings_duplicates") }}
										/>
									}
									label={t("settings_duplicates")}
								/>
							</Box>
						</Tooltip>
					</Grid2>
					<Grid2 size={{ xs: 6 }}>
						<Tooltip title={<div>{t("settings_free_text_tooltip")}</div>}>
							<Box>
								<FormControlLabel
									sx={{ m: 0, width: "100%", '& .MuiFormControlLabel-label': { fontSize: '0.95rem' } }}
									control={
										<Checkbox
											size="small"
											sx={{ p: 0.45 }}
											checked={!props.electionSettings.constraints.no_freesolo}
											onChange={(e) => {
												props.setElectonSettings({ ...props.electionSettings, constraints: { ...props.electionSettings.constraints, no_freesolo: !e.target.checked } });
											}}
											inputProps={{ "aria-label": t("settings_free_text") }}
										/>
									}
									label={t("settings_free_text")}
								/>
							</Box>
						</Tooltip>
					</Grid2>
					<Grid2 size={{ xs: 6 }}>
						<Tooltip title={<div>{t("settings_autocomplete_tooltip")} <b>{t("settings_type_chip")}</b> {t("settings_type_ballot")}</div>}>
							<Box>
								<FormControlLabel
									sx={{ m: 0, width: "100%", '& .MuiFormControlLabel-label': { fontSize: '0.95rem' } }}
									control={
										<Checkbox
											size="small"
											sx={{ p: 0.45 }}
											checked={props.electionSettings.constraints.autocomplete}
											onChange={(e) => {
												props.setElectonSettings({ ...props.electionSettings, constraints: { ...props.electionSettings.constraints, autocomplete: e.target.checked } });
											}}
											inputProps={{ "aria-label": t("settings_autocomplete") }}
										/>
									}
									label={t("settings_autocomplete")}
								/>
							</Box>
						</Tooltip>
					</Grid2>
					<Grid2 size={{ xs: 6 }}>
						<Tooltip title={<div>{t("settings_warnings_tooltip")}</div>}>
							<Box>
								<FormControlLabel
									sx={{ m: 0, width: "100%", '& .MuiFormControlLabel-label': { fontSize: '0.95rem' } }}
									control={
										<Checkbox
											size="small"
											sx={{ p: 0.45 }}
											checked={props.electionSettings.constraints.allow_warning}
											onChange={(e) => {
												props.setElectonSettings({ ...props.electionSettings, constraints: { ...props.electionSettings.constraints, allow_warning: e.target.checked } });
											}}
											inputProps={{ "aria-label": t("settings_warnings") }}
										/>
									}
									label={t("settings_warnings")}
								/>
							</Box>
						</Tooltip>
					</Grid2>
					<Grid2 size={{ xs: 6 }}>
						<Tooltip title={<div>{t("settings_checks_tooltip")} <b>{t("settings_type_table")}</b> {t("settings_type_ballot")}</div>}>
							<Box>
								<FormControlLabel
									sx={{ m: 0, width: "100%", '& .MuiFormControlLabel-label': { fontSize: '0.95rem' } }}
									control={
										<Checkbox
											size="small"
											sx={{ p: 0.45 }}
											checked={props.electionSettings.constraints.enable_check}
											onChange={(e) => {
												props.setElectonSettings({ ...props.electionSettings, constraints: { ...props.electionSettings.constraints, enable_check: e.target.checked } });
											}}
											inputProps={{ "aria-label": t("settings_checks") }}
										/>
									}
									label={t("settings_checks")}
								/>
							</Box>
						</Tooltip>
					</Grid2>
						</Grid2>
					</Box>
				</Grid2>
			</Grid2>
		</Grid2>
	)
}
